import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { AlertService } from '../../../../core/services/alert.service';
import { FooterLanguagesComponent } from './footer-languages/footer-languages.component';
import { SharedModule } from '../../../../shared/shared-module';
import { PlatformService } from '../../../../core/services/platform.service';
import { I18nDetectorService } from '../../../../core/services/i18n.detector.service';
@Component({
  selector: '[app-footer]',
  imports: [FooterLanguagesComponent, SharedModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  constructor(public alertService: AlertService,
    public pt: PlatformService,
    public i18nService: I18nDetectorService
  ) { }
}
